import { render, staticRenderFns } from "./people-count-bar-chart.vue?vue&type=template&id=76fd11a6&scoped=true&"
import script from "./people-count-bar-chart.vue?vue&type=script&lang=js&"
export * from "./people-count-bar-chart.vue?vue&type=script&lang=js&"
import style0 from "./people-count-bar-chart.vue?vue&type=style&index=0&id=76fd11a6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76fd11a6",
  null
  
)

export default component.exports